export default "__VITE_ASSET__eca49375__"